import { BOBBY_API_ROOT } from '../constants';

export const ANALYTICS_EVENT_PATH: string = `${BOBBY_API_ROOT}/backoffice/event`;
